import { ArabicEach } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'product_list_title',
      dataType: ['design', 'design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_paddingLeft'],
      englishTitleRight: ['right', 'self_paddingRight']
    },
    {
      flag: 'product_list_button',
      dataType: ['design', 'design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
